// extracted by mini-css-extract-plugin
module.exports = {"ipad_layout":"ipad_layout-2xqLEfs9","layout":"layout-2evNrIZw","headAd":"headAd-1zgq-YAX","section":"section-2txYbGfI","bottomAd":"bottomAd-1QhByuJq"};